import { Box, Icon, Spinner } from '@chakra-ui/react';
import { FaComment } from 'react-icons/fa6';
import { useLayoutEffect, useRef } from 'react';

import { ChatMessage } from './chat-message';
import { Message } from '../types';

type ChatContainerProps = {
  messages: Message[];
  loading: boolean;
};

export const ChatContainer = ({ messages, loading }: ChatContainerProps) => {
  const endRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    endRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return <Box display='flex' flexDirection='column' gap={2} flex={1} backgroundColor='gray.100' overflowY="scroll" overflowX="hidden"> 
    {!messages.length && <Box display='flex' justifyContent='center' alignItems='center' flex={1}>
      <Box display='flex' justifyContent='center' alignItems='center' flex={1}>
        <Box display='flex' justifyContent='center' alignItems='center' flex={1}>
          <Icon as={FaComment} size='24px' color='gray.500' />
          <Box ml={2}>Пока нет сообщений</Box>
        </Box>
      </Box>
    </Box>}
    {messages.map(({ id, message, from, date }) => <ChatMessage key={id} message={message} from={from} date={date} id={id} />)}

    <Box ref={endRef}  h="3px" w="100%" />
    {loading && <Box display='flex' pl={3} justifyContent='flex-start' alignItems='center' flex={1}>
      <Box display='flex' justifyContent='flex-start' alignItems='flex-start'>
        <Spinner size='sm' color='gray.500' />
        <Box ml={2} fontSize={12}>Ждем ответа...</Box>
      </Box>
    </Box>}
  </Box>;
};